module.exports = __webpack_public_path__ + "img/icon_pdf_ring.98e8b92c.svg";